import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'swb-page-storyboards',
  templateUrl: './page-storyboards.component.html'
})
export class PageStoryboardsComponent implements OnInit {
  public query: string;

  @Output() filterEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  public filter(query: string): void {
    this.query = query;
  }

}
